import { urlBaseLeadCollector } from "../config";
import axiosInstance from "../../services/config/axiosinstance";

export default async function getOrganization(organizationName = '') {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseLeadCollector}/organization/getOrganization?organizationName=${organizationName}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data?.data;
  } catch (error) {
    console.log('Error getOrganization', error);
    throw error;
  }
}
